"use client";

import { getGameHandler } from "@/games";
import CardArt from "@/components/Card/CardArt";
import { replaceKeywords } from "@/components/keywords";
import { OPItem } from "@/interfaces/CardItem";
import { useCurrentGame } from "@/stores/deckStore";
import { orientationOfCard } from "@/lib/cardArt";

/**
 * The card preview shown on hover in the side deck layout.
 *
 * This used to import One Piece's getCardImage and getCardData directly, so it
 * showed One Piece art whichever game's deck was open. It reads the game from
 * the deck store now, like the rest of the builder.
 */
export default function CardTooltip({ id }: { id: string }) {
  const game = useCurrentGame();

  if (!id) return null;

  const handler = getGameHandler(game);
  const cardData = handler.getDeckBuilderCardFunctions().getCardData(id);

  return (
    <div className="m-2 flex flex-col items-center justify-center">
      <div className="w-[350px]">
        <CardArt
          src={handler.getCardImage(id, "original", "")}
          alt={cardData?.name ?? id}
          orientation={orientationOfCard(game, cardData)}
          loading="eager"
          fetchPriority="high"
          radiusClassName="rounded-[10px]"
        />
        {(cardData as OPItem)?.region !== "EN" && (
          <div className="leading-loose my-4">
            <p>
              {cardData && replaceKeywords((cardData as OPItem).description)}
            </p>
            <p>
              {(cardData as OPItem)?.trigger &&
                replaceKeywords((cardData as OPItem).trigger ?? "")}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
